module.exports = __webpack_public_path__ + "static/media/RP-A_C_Embroidery_Vela_Dark grey_White.50ac4b56.png";